(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gat-chat-control"] && !Shopify.designMode) return;
  try {
    function gatInitChatControl(){
    const root=document.documentElement;
    const mobile=window.matchMedia('(max-width:768px)');
    let api=null;
    let requested=false;
    let opened=false;
    let lastTrigger=null;
    function fitChat(){
      const shadow=document.querySelector('#tidio-chat')?.shadowRoot;
      if(!shadow||shadow.querySelector('#gat-chat-viewport'))return;
      const style=document.createElement('style');
      style.id='gat-chat-viewport';
      style.textContent='@media(max-width:768px){#tidio-chat-root{width:calc(100vw - 32px)!important;max-width:calc(100vw - 32px)!important;left:0!important;right:0!important;margin-left:16px!important;margin-right:16px!important}#tidio-chat-root .chat{width:100%!important;max-width:100%!important;box-sizing:border-box}}';
      shadow.appendChild(style);
    }
    function inlineMobile(){return mobile.matches&&!!document.querySelector('[data-gat-open-chat]');}
    function sync(){
      root.classList.toggle('gat-mobile-chat-open',opened);
      if(!api)return;
      if(inlineMobile()&&!opened)api.hide();
      else api.show();
    }
    function ready(){
      if(api)return;
      api=window.tidioChatApi;
      if(!api)return;
      api.setFeatures({mobileHash:false});
      fitChat();
      api.on('beforeOpen',function(){
        if(!requested)root.classList.add('gat-chat-suppressed');
      });
      api.on('open',function(){
        if(!requested){api.close();return;}
        opened=true;
        fitChat();
        root.classList.remove('gat-chat-suppressed');
        root.classList.add('gat-mobile-chat-open');
      });
      api.on('close',function(){
        opened=false;
        requested=false;
        root.classList.remove('gat-mobile-chat-open','gat-chat-suppressed');
        if(inlineMobile())api.hide();
        if(lastTrigger&&mobile.matches)lastTrigger.focus({preventScroll:true});
      });
      api.close();
      sync();
      document.querySelectorAll('[data-gat-open-chat]').forEach(function(button){button.dataset.chatReady='true';});
    }
    document.addEventListener('click',function(event){
      if(!event.isTrusted)return;
      const path=event.composedPath();
      if(path.some(function(node){return node.id==='tidio-chat';}))requested=true;
      const trigger=event.target.closest&&event.target.closest('[data-gat-open-chat]');
      if(!trigger||!api)return;
      event.preventDefault();
      lastTrigger=trigger;
      requested=true;
      opened=true;
      root.classList.remove('gat-chat-suppressed');
      sync();
      api.open();
    },true);
    mobile.addEventListener('change',sync);
    document.addEventListener('tidioChat-ready',ready);
    if(window.tidioChatApi){
      window.tidioChatApi.on('ready',ready);
      if(typeof window.tidioChatApi.getStatus==='function'&&window.tidioChatApi.getStatus()!=null)ready();
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',gatInitChatControl,{once:true});
  else gatInitChatControl();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gat-product-share"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-gat-copy]');
    if (!button) return;
    const toolbar = button.closest('.gat-product-share');
    const status = toolbar.querySelector('.gat-product-share__status');
    const label = button.querySelector('[data-copy-text]');
    const fallback = toolbar.querySelector('.gat-product-share__fallback');
    try {
      await navigator.clipboard.writeText(toolbar.dataset.shareUrl);
      fallback.hidden = true;
      label.textContent = toolbar.dataset.copiedLabel;
      status.textContent = toolbar.dataset.copySuccess;
      clearTimeout(button.gatResetTimer);
      button.gatResetTimer = setTimeout(function() {
        label.textContent = toolbar.dataset.copyLabel;
        status.textContent = '';
      }, 4000);
    } catch (error) {
      status.textContent = toolbar.dataset.copyFallback;
      fallback.hidden = false;
      fallback.focus();
      fallback.select();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
